import { useTheme } from '@mui/material';
import { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';

const DragHandleIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    style={{ display: 'block', opacity: 0.9, pointerEvents: 'none' }}
  >
    <g fill="currentColor">
      <circle cx="8" cy="4.5" r="2.6" />
      <circle cx="16" cy="4.5" r="2.6" />
      <circle cx="8" cy="12" r="2.6" />
      <circle cx="16" cy="12" r="2.6" />
      <circle cx="8" cy="19.5" r="2.6" />
      <circle cx="16" cy="19.5" r="2.6" />
    </g>
  </svg>
);

interface DragHandleProps {
  dragDisabled?: boolean;
  isDragging?: boolean;
  [key: string]: unknown;
}

export const DragHandle = memo(
  forwardRef<HTMLButtonElement, DragHandleProps>(function DragHandle(
    { dragDisabled = false, isDragging = false, ...props },
    ref,
  ) {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
      <button
        ref={ref}
        {...props}
        type="button"
        aria-label={t('common.tooltips.drag_handle')}
        style={{
          width: 28,
          height: 28,
          margin: 0,
          padding: 0,
          border: 0,
          background: 'transparent',
          display: 'grid',
          placeItems: 'center',
          cursor: dragDisabled ? 'default' : isDragging ? 'grabbing' : 'grab',
          touchAction: 'none',
          userSelect: 'none',
          color: theme.palette.primary.dark,
          fontSize: 18,
        }}
      >
        <DragHandleIcon />
      </button>
    );
  }),
);
